import { render, staticRenderFns } from "./ClinicItem.vue?vue&type=template&id=eda48f44"
import script from "./ClinicItem.vue?vue&type=script&lang=js"
export * from "./ClinicItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports